import { render, staticRenderFns } from "./PreferencesView.vue?vue&type=template&id=28ed070b&scoped=true"
import script from "./PreferencesView.vue?vue&type=script&lang=js"
export * from "./PreferencesView.vue?vue&type=script&lang=js"
import style0 from "./PreferencesView.vue?vue&type=style&index=0&id=28ed070b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ed070b",
  null
  
)

export default component.exports